module.exports = __webpack_public_path__ + "static/media/find-created-page.e27e0fb5.png";